import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import axios from "../utils/axiosConfig";

const AdminClosedDealEditDialog = ({ deal, onCancel, onApproved }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setUsername("");
    setPassword("");
    setError("");
    setSubmitting(false);
  }, [deal]);

  if (!deal) return null;

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const response = await axios.post("/auth/closed-deal-edit-approval", {
        username,
        password,
        dealId: deal.DealID
      });
      setPassword("");
      onApproved(response.data.approvalToken);
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.message || "Administrator approval failed");
    } finally {
      setSubmitting(false);
    }
  };

  return createPortal(
    <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.68)", zIndex: 1080 }} role="dialog" aria-modal="true" aria-labelledby="closed-deal-approval-title">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <form onSubmit={submit}>
            <div className="modal-header">
              <h5 className="modal-title" id="closed-deal-approval-title">Administrator approval required</h5>
              <button type="button" className="btn-close" aria-label="Cancel" onClick={onCancel} disabled={submitting}></button>
            </div>
            <div className="modal-body">
              <p className="mb-3">
                Deal <strong>{deal.DealNo || deal.DealID}</strong> is closed. An administrator with Deal Edit permission must approve before it can be edited.
              </p>
              {error && <div className="alert alert-danger py-2" role="alert">{error}</div>}
              <div className="mb-3">
                <label className="form-label" htmlFor="closed-deal-admin-username">Administrator username</label>
                <input id="closed-deal-admin-username" className="form-control" value={username} data-no-uppercase
                  onChange={(event) => setUsername(event.target.value)} autoComplete="username" autoFocus required />
              </div>
              <div>
                <label className="form-label" htmlFor="closed-deal-admin-password">Administrator password</label>
                <input id="closed-deal-admin-password" type="password" className="form-control" value={password} data-no-uppercase
                  onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" required />
              </div>
              <div className="form-text mt-2">Approval applies only to this deal and expires after 30 minutes.</div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={submitting}>Cancel</button>
              <button type="submit" className="btn btn-primary" disabled={submitting || !username || !password}>
                {submitting ? "Verifying..." : "Approve and edit"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AdminClosedDealEditDialog;
